module.exports = __webpack_public_path__ + "img/ocean-restaurant.95078b21.jpg";